import type { SVGProps } from 'react';

const SvgSidebarRight = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill={props.color}
      d="M7 9a1 1 0 0 0 0 2h3a1 1 0 1 0 0-2zM6 14a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1"
    />
    <path
      fill={props.color}
      fillRule="evenodd"
      d="M5 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zm8 2H5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8zm2 14h4a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-4z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgSidebarRight;
